/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleDown: {
  name: 'triangle-down';
  data: string;
} = {
  name: 'triangle-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.057 9H8.943a1 1 0 0 0-.814 1.581l3.057 4.28a1 1 0 0 0 1.628 0l3.056-4.28A1 1 0 0 0 15.057 9Z" fill="currentColor"/></svg>`,
};
